module.exports = __webpack_public_path__ + "img/03.41a10514.png";